export const convertDate = (str) => {
  const decodedDate = atob(str);

  const [year, month, day] = decodedDate.split("-");
  const date = new Date(Date.UTC(year, month - 1, day));
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  };
  const formattedDate = date.toLocaleDateString(undefined, options);
  return formattedDate;
};

export const calculateTrialDaysLeft = (encodedDate) => {
  const decodedDate = atob(encodedDate);
  const [year, month, day] = decodedDate.split("-");

  // Create date object for the start of the trial
  const startDate = new Date(Date.UTC(year, month - 1, day));

  // Calculate the end date by adding 7 days to the start date
  const trialEndDate = new Date(startDate);
  trialEndDate.setDate(trialEndDate.getDate() + 7);

  // Get today's date
  const today = new Date();

  // Calculate the difference in milliseconds
  const timeDiff = trialEndDate - today;

  // Convert difference from milliseconds to days
  const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  return daysLeft;

  /*  if (daysLeft > 0) {
    return `${daysLeft} day(s) left in your free trial.`;
  } else if (daysLeft === 0) {
    return "Your free trial ends today. You will be charged tomorrow!";
  } else {
    return "Your free trial has ended. You have been charged.";
  } */
};
